import { useEffect, useRef, useState } from "react";
import { RewardsService } from "../../../../services/RewardsService";
import { ChangeAlertCallbackType } from "../../../Root";
import { RewardsProps } from "../types";
import moment from "moment";
moment.locale("es");

export const useRewardsUpdate = (changeAlert: ChangeAlertCallbackType) => {
    const [loading, setLoading] = useState(false);
    const rewardsService = useRef<RewardsService>();

    const validateService = (action, tabActive) => {
        let service = "";
        let getService = "";

        switch (tabActive+"|"+action) {
            case "promotions|Crear":
            case "history_promo|Crear":
                service = "rewardsPromotionsInsert";
                getService = "rewardsPromotionsGet";
                break;
            case "promotions|Editar":
            case "history_promo|Editar":
                service = "rewardsPromotionsUpdate";
                getService = "rewardsPromotionsGet";
                break;
            case "configuration|Crear":           
            case "history_config|Crear":
                service = "rewardConfigurationInsert";
                getService = "rewardConfigurationGet";
                break;
            case "configuration|Editar":            
            case "history_config|Editar":
                service = "rewardConfigurationUpdate";
                getService = "rewardConfigurationGet";
                break;
        }

        return { service, getService }
    }
    const manageReward = async (data: RewardsProps, action: string, tabActive: string, getData: any) => {
        setLoading(true);
        const { service, getService } = validateService(action, tabActive);
        const response = await rewardsService.current[service]({data: data});
        
        if (response.data?.response === "OK") {
            setLoading(false);
            changeAlert(true, "success", `El registro ha sido ${action === "Editar" ? "actualizado" : "creado"} con éxito`);
            getData(getService);
        } else {
            setLoading(false);
            changeAlert(true, "error", response.data.message);
        }
    };

    useEffect(() => {
        rewardsService.current = new RewardsService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { loading, manageReward };
};
